import { useMemo } from 'react';
import { defaultSectionRegistry } from 'ai-rendering-library/sections/formatters/registry';
import { buildTextBlockMessagePayload } from 'ai-rendering-library/sections/breezeEngine/buildMessagePayload';
import { ActionsResponseSectionTypename, CatalogItemRecommendationSectionTypename, PlaylistSuggestionTypename } from '../../types';
import { RecommendationCard } from '../DynamicSections/AcademyRecommendations';
import { AcademySuggestionButtons } from '../DynamicSections/AcademySuggestionButtons';
import { PlaylistSuggestionCard } from '../DynamicSections/PlaylistSuggestionCard';
import { attachPlaylistDraftContext, injectUncitedPlaylist, isCatalogRecommendationSection, isPlaylistSuggestionSection, normalizePlaylistSuggestion } from '../DynamicSections/playlistSuggestionUtils';
import AISectionV2 from 'ai-rendering-library/sections/AISectionV2';
import { AssistantMessageWrapper } from './AssistantMessageWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const hasPlaylistSection = message => {
  var _message$dynamicSecti;
  return ((_message$dynamicSecti = message.dynamicSectionContainers) !== null && _message$dynamicSecti !== void 0 ? _message$dynamicSecti : []).some(c => isPlaylistSuggestionSection(c.responseSection));
};
const renderPlaylistSuggestion = ({
  section,
  message
}) => {
  if (!isPlaylistSuggestionSection(section)) return null;
  return /*#__PURE__*/_jsx(PlaylistSuggestionCard, {
    message: message,
    section: normalizePlaylistSuggestion(section)
  });
};
const renderCatalogRecommendation = ({
  section,
  message
}) => {
  // Playlist and catalog cards are mutually exclusive in the same message.
  if (hasPlaylistSection(message)) return null;
  if (!isCatalogRecommendationSection(section)) return null;
  return /*#__PURE__*/_jsx(RecommendationCard, {
    section: section
  });
};
const academyRegistry = Object.assign({}, defaultSectionRegistry, {
  [CatalogItemRecommendationSectionTypename]: renderCatalogRecommendation,
  [ActionsResponseSectionTypename]: ({
    section
  }) => /*#__PURE__*/_jsx(AcademySuggestionButtons, {
    section: section
  }),
  [PlaylistSuggestionTypename]: renderPlaylistSuggestion
});

// Strip trailing `.` / `:` after section markers so prose punctuation next to
// `[RESPONSE_SECTION_n]` does not leak into the rendered text.
const PERIOD_AFTER_SECTION_MARKER_REGEX = /(\[RESPONSE_SECTION_\d+\])[.:]+/g;
const AcademyTextBlock = ({
  block,
  message
}) => {
  var _message$id, _messagePayload$secti;
  const textBlock = block;
  const sectionId = (_message$id = message === null || message === void 0 ? void 0 : message.id) !== null && _message$id !== void 0 ? _message$id : '';
  const messagePayload = useMemo(() => {
    const cleanedTextBlock = Object.assign({}, textBlock, {
      text: textBlock.text.replace(PERIOD_AFTER_SECTION_MARKER_REGEX, '$1')
    });
    const payload = buildTextBlockMessagePayload(cleanedTextBlock, sectionId, message);
    const withPlaylistContext = attachPlaylistDraftContext(payload, cleanedTextBlock);
    return injectUncitedPlaylist(withPlaylistContext, message);
  }, [textBlock, sectionId, message]);
  const sections = (_messagePayload$secti = messagePayload.sections) !== null && _messagePayload$secti !== void 0 ? _messagePayload$secti : [];
  return sections.map((section, i) => /*#__PURE__*/_jsx(AISectionV2, {
    message: messagePayload,
    section: section,
    registry: academyRegistry
  }, i));
};
export const ACADEMY_BLOCK_RENDERERS = {
  TEXT: AcademyTextBlock,
  MESSAGE: AssistantMessageWrapper
};